import React from "react";
import { useTranslation } from "react-i18next";
import PageHead from "@/components/PageHead";

export default function CookiePolicy() {
  const { t } = useTranslation();
  const sections = Array.from({ length: 8 }, (_, i) => i + 1);
  const openPrefs = () => {
    window.dispatchEvent(new CustomEvent("argengeo:open-cookie-preferences"));
  };
  return (
    <>
      <PageHead titleKey="meta.cookies.title" descriptionKey="meta.cookies.description" />
      <section className="ag-section ag-legal">
        <div className="ag-container ag-legal__inner">
          <span className="ag-eyebrow">{t("nav.cookies")}</span>
          <h1 className="ag-h1">{t("cookies.title")}</h1>
          <p className="ag-legal__updated">{t("cookies.updated")}</p>
          <p className="ag-legal__intro">{t("cookies.intro")}</p>
          {sections.map((n) => (
            <div className="ag-legal__section" key={n}>
              <h2>{t(`cookies.s${n}Title`)}</h2>
              <p>{t(`cookies.s${n}Body`)}</p>
            </div>
          ))}
          <button type="button" className="ag-btn ag-btn--primary" onClick={openPrefs}>
            {t("cookies.managePreferencesCta")}
          </button>
        </div>
      </section>
    </>
  );
}
